let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("3xznI"), load("5WLpx")]).then(() => parcelRequire('lEolr'));